import { render, staticRenderFns } from "./CardiomiopatieView.vue?vue&type=template&id=90b152c6"
import script from "./CardiomiopatieView.vue?vue&type=script&lang=js"
export * from "./CardiomiopatieView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports